import { useEffectOnce } from '@carvana/vdp-react-hooks';
import { useContext, useRef } from 'react';
import SortOption from '~/constants/SortOption';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';

const useGetSortByChanged = () => {
  const { sortBy } = useContext(AppliedFiltersContext);
  const isInitialSortBy = useRef(true);

  useEffectOnce(
    () => {
      isInitialSortBy.current = false;
    },
    [],
    sortBy !== SortOption.MostPopular
  );

  return isInitialSortBy.current;
};

export default useGetSortByChanged;
